import React from 'react';

import { Tooltip } from 'components';
import { useBreakpoint } from 'hooks';
import { TooltipProps } from 'components/Tooltip';

const MobileFriendlyTooltip: React.FC<TooltipProps> = props => {
  const { md } = useBreakpoint();
  return (
    <Tooltip
      trigger={md ? ['hover'] : []}
      overlayInnerStyle={{ textAlign: 'center' }}
      {...props}
      {...(!md ? { open: false } : {})}
    >
      {props.children}
    </Tooltip>
  );
};

export default MobileFriendlyTooltip;
